/* Maison du Booster : extrait de snippets/mdb-ux-collection.liquid (23/09, charge en defer) */
  (function () {
    var MDB = window.MDB = window.MDB || {};
    var GRAND = window.matchMedia('(min-width: 990px)');
    var CLE = 'mdb-defil:' + location.pathname + location.search;
    var DUREE_MAX = 30 * 60 * 1000;

    /* ---- mémoire de la position : retour d'une fiche = même endroit, même produit à l'écran ----
       Le thème fait défiler .page-wrapper à partir de 990 px (la fenêtre en dessous) ; sa propre restauration
       s'enregistre trop tard (module chargé après « pageshow ») : la page revenait en haut sur ordinateur et 1 rangée
       trop haut sur mobile. On mémorise le produit cliqué et sa position à l'écran, puis on le replace. */
    try { history.scrollRestoration = 'manual'; } catch (e) {}
    function conteneur() {
      return (GRAND.matches && document.querySelector('.page-wrapper')) || document.scrollingElement || document.documentElement;
    }
    var derniereCarte = null, heureClic = 0;
    function memoriser() {
      try {
        var c = conteneur(), carte = derniereCarte;
        if (!carte || !document.contains(carte) || Date.now() - heureClic > 10000) {
          carte = null;
          var cartes = document.querySelectorAll('.product-grid__item[data-product-id]');
          for (var i = 0; i < cartes.length; i++) { if (cartes[i].getBoundingClientRect().bottom > 96) { carte = cartes[i]; break; } }
        }
        sessionStorage.setItem(CLE, JSON.stringify({
          y: c.scrollTop,
          id: carte ? carte.getAttribute('data-product-id') : null,
          haut: carte ? Math.round(carte.getBoundingClientRect().top) : 0,
          t: Date.now()
        }));
      } catch (e) {}
    }
    document.addEventListener('click', function (e) {
      var li = e.target.closest ? e.target.closest('.product-grid__item[data-product-id]') : null;
      if (!li || (e.target.closest('button, input, label, select'))) return;
      derniereCarte = li; heureClic = Date.now();
      memoriser();
    }, true);
    window.addEventListener('pagehide', memoriser);

    var nav = (window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
    var etat = null, actif = false, fini = false;
    function appliquer() {
      if (!etat || fini) return;
      var c = conteneur(), cible = etat.y;
      var carte = etat.id ? document.querySelector('.product-grid__item[data-product-id="' + etat.id + '"]') : null;
      if (carte) cible = c.scrollTop + carte.getBoundingClientRect().top - etat.haut;
      cible = Math.max(0, Math.min(cible, c.scrollHeight - c.clientHeight));
      if (Math.abs(c.scrollTop - cible) > 1) c.scrollTo({ top: cible, behavior: 'instant' });
    }
    MDB.defilement = {
      restaurer: function () {
        if (actif || (nav.type !== 'back_forward' && nav.type !== 'reload')) return;
        try { etat = JSON.parse(sessionStorage.getItem(CLE) || 'null'); } catch (e) { etat = null; }
        if (!etat || Date.now() - etat.t > DUREE_MAX) return;
        actif = true;
        appliquer();
        /* on réajuste le temps que la page se stabilise (polices, restauration du thème), sauf si la personne bouge */
        function stop() { fini = true; }
        ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(function (t) { window.addEventListener(t, stop, { passive: true, once: true, capture: true }); });
        document.addEventListener('DOMContentLoaded', appliquer);
        window.addEventListener('load', function () { appliquer(); requestAnimationFrame(appliquer); });
        window.addEventListener('pageshow', function () { requestAnimationFrame(function () { requestAnimationFrame(appliquer); }); });
        setTimeout(function () { appliquer(); fini = true; }, 1600);
      }
    };

    /* ---- ajout rapide : nom accessible complet (« Ajouter au panier : <produit> ») ---- */
    function libellesAjout() {
      document.querySelectorAll('.mdb-carte quick-add-component').forEach(function (q) {
        var t = q.getAttribute('data-product-title'), b = q.querySelector('.quick-add__button--add');
        if (b && t && b.getAttribute('aria-label') !== 'Ajouter au panier : ' + t) b.setAttribute('aria-label', 'Ajouter au panier : ' + t);
      });
    }

    /* ---- pastilles de sous-catégories : fondu qui signale la suite, pastille courante visible ---- */
    function pastilles() {
      document.querySelectorAll('.mdb-souscat ul').forEach(function (ul) {
        function maj() {
          ul.classList.toggle('a-gauche', ul.scrollLeft > 4);
          ul.classList.toggle('a-droite', ul.scrollLeft + ul.clientWidth < ul.scrollWidth - 4);
        }
        if (!ul.dataset.mdbPret) {
          ul.dataset.mdbPret = '1';
          var cur = ul.querySelector('[aria-current]');
          if (cur && ul.scrollWidth > ul.clientWidth) {
            var li = cur.parentElement, x = li.offsetLeft - (ul.clientWidth - li.offsetWidth) / 2;
            if (x > 0) ul.scrollLeft = x;
          }
          ul.addEventListener('scroll', function () { requestAnimationFrame(maj); }, { passive: true });
          window.addEventListener('resize', maj, { passive: true });
        }
        maj();
      });
    }

    /* ---- chargement / erreur pendant le rafraîchissement des filtres et du tri ---- */
    document.addEventListener('shopify:collection:update', function (e) {
      var rl = document.querySelector('results-list');
      if (!rl) return;
      rl.classList.add('mdb-chargement');
      rl.setAttribute('aria-busy', 'true');
      function fin() { rl.classList.remove('mdb-chargement'); rl.removeAttribute('aria-busy'); }
      var minuterie = setTimeout(fin, 8000);
      var p = e.promise || (e.detail && e.detail.promise);
      if (p && typeof p.then === 'function') {
        p.then(function () { clearTimeout(minuterie); fin(); }, function (err) {
          clearTimeout(minuterie); fin();
          if (err && err.name === 'AbortError') return;
          if (MDB.toast) MDB.toast('Les produits n’ont pas pu être mis à jour. Vérifiez votre connexion.', { type: 'erreur', action: { libelle: 'Réessayer', fn: function () { location.reload(); } } });
        });
      }
    });

    /* ---- intro de collection : 3 lignes sur téléphone + « Lire la suite » (divulgation progressive) ---- */
    function intro() {
      var d = document.querySelector('main[data-template^="collection"] .text-block.rte');
      if (!d || d.dataset.mdbPlie || !d.textContent.trim()) return;
      d.dataset.mdbPlie = '1';
      if (d.scrollHeight <= d.clientHeight + 2) return;   /* 3 lignes ou moins : rien à replier */
      d.id = d.id || 'mdb-intro-collection';
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'mdb-desc-bouton'; b.textContent = 'Lire la suite';
      b.setAttribute('aria-expanded', 'false'); b.setAttribute('aria-controls', d.id);
      b.addEventListener('click', function () {
        var ouvert = d.classList.toggle('mdb-desc-ouverte');
        b.textContent = ouvert ? 'Réduire' : 'Lire la suite';
        b.setAttribute('aria-expanded', String(ouvert));
      });
      d.appendChild(b);
    }

    function init() {
      intro();
      libellesAjout();
      pastilles();
      var zone = document.querySelector('collection-component') || document.querySelector('main');
      if (zone && 'MutationObserver' in window) {
        var attente = false;
        new MutationObserver(function () {
          if (attente) return;
          attente = true;
          requestAnimationFrame(function () { attente = false; libellesAjout(); });
        }).observe(zone, { childList: true, subtree: true });
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();
